import superagent from 'superagent';

const BASE = '/api/jobs/browser/search-v3';

export default ({ qs }) => new Promise((resolve, reject) => {
  superagent.get(`${BASE}?${qs}`)
    .then(response => resolve(response))
    .catch((error) => reject(error));
});
